<script setup lang="ts">
import type { FerryProductCardData, FerryUpsellType } from '../../../models';

import FerryProductCardContent from './FerryProductCardContent.vue';

interface FerryProductCardProps {
  productCardData: FerryProductCardData;
  printMode?: boolean;
  shouldHideProductLink: boolean;
}

const props = defineProps<FerryProductCardProps>();

interface FerryProductCardEmits {
  (event: 'change-upsell', upsellType: FerryUpsellType): void;
  (event: 'show-details'): void;
  (event: 'change-ferry'): void;
  (event: 'remove-ferry'): void;
}

const emit = defineEmits<FerryProductCardEmits>();
</script>

<template>
  <div
    class="ferry-product-card"
    :class="{
      'print-mode': props.printMode,
    }"
  >
    <FerryProductCardContent
      :product-card-content="props.productCardData"
      :print-mode="props.printMode"
      :should-hide-product-link="props.shouldHideProductLink"
      @change-upsell="emit('change-upsell', $event)"
      @show-details="emit('show-details')"
      @change-ferry="emit('change-ferry')"
      @remove-ferry="emit('remove-ferry')"
    />
  </div>
</template>

<style scoped lang="scss">
.ferry-product-card {
  background: var(--color-white);
  border: 1px solid var(--color-neutral-30);
  border-radius: var(--border-radius-8);
  overflow: hidden;
}
</style>
